import { render } from "./legoSegmentWrapper.vue?vue&type=template&id=4fb6a293"
import script from "./legoSegmentWrapper.vue?vue&type=script&lang=js"
export * from "./legoSegmentWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoSegmentButton/legoSegmentWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fb6a293"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fb6a293', __exports__)) {
    api.reload('4fb6a293', __exports__)
  }
  
  module.hot.accept("./legoSegmentWrapper.vue?vue&type=template&id=4fb6a293", () => {
    api.rerender('4fb6a293', render)
  })

}


export default __exports__